import { useAtomValue } from 'jotai';
import { FC, useCallback } from 'react';
import { LineChart } from '../../../../components/Charts/LineChart/LineChart';
import { IMetricsDataModel } from '../../../../data-models/metrics.data-model';
import { sectorsByIdMapAtom } from '../../../../services/state/AppConfigStateJ';
import { sectorsColourState } from '../../../../services/state/SectorStateJ';
import { CHART_COMPONENTS } from '../../../../types';
import { GroupExtractorFn, useIrrByGroup } from '../../hooks/useIrrByGroup';
import { IPortfolioChartProps } from './ChartComponent';
import { allChartItems } from './ChartsSection';

export const IrrBySector: FC<IPortfolioChartProps<IMetricsDataModel>> = (props) => {
  const sectorMap = useAtomValue(sectorsByIdMapAtom);

  const sectorExtractor = useCallback<GroupExtractorFn>(
    ({ company }) => sectorMap.get(company?.sectorId ?? -1)?.name ?? '',
    [sectorMap]
  );
  const { data } = useIrrByGroup(props.filteredMetrics, sectorExtractor);
  const yFormatter = useCallback((tick: string | number) => `${Number(tick).toFixed(1)}%`, []);
  const sectorColours = useAtomValue(sectorsColourState);

  return (
    <LineChart
      yAxisLabelFormatter={yFormatter}
      data={data}
      chartColors={sectorColours}
      id={CHART_COMPONENTS.IRR_BY_SECTOR}
      title={allChartItems.get(CHART_COMPONENTS.IRR_BY_SECTOR)?.value ?? 'IRR by Sector'}
      width={640}
      isFullScreen={props.isFullScreen}
      onOpenFullScreen={props.onOpenFullScreen}
    />
  );
};
